import { Suspense } from 'react';
import { Button } from '@givebutter/primitives/button';
import { Loader } from '@givebutter/primitives/loader';
import * as Dialog from '@radix-ui/react-dialog';
import { TasksHeader } from 'components/tasks/list/TasksHeader';
import { TasksList } from 'components/tasks/list/TasksList';

const Tasks = () => {
    return (
        <>
            <TasksHeader />
            <div className="bg-gray-25 relative flex-grow overflow-y-auto">
                <Suspense fallback={<Loader />}>
                    <TasksList />
                </Suspense>
            </div>
            <div className="flex justify-end border-t border-gray-200 bg-gray-50 px-6 py-4">
                <Dialog.Trigger asChild>
                    <Button variant="outline" color="neutral">
                        Close
                    </Button>
                </Dialog.Trigger>
            </div>
        </>
    );
};

export { Tasks };
